module.exports = __webpack_public_path__ + "img/icon.7781ef4f.svg";